import { useParams } from "next/navigation";
import { getStoreIdFromSlug } from "lib/utils";

function useStoreId() {
  const { slug } = useParams();

const storeId = getStoreIdFromSlug(slug)

  return { storeId: Number(storeId) };
}

export default useStoreId;
